import React from 'react';
import { Database, Plus, Play, Save, Eye, Check, Loader2 } from 'lucide-react';

const Toolbar = ({
  onAddNode,
  onRun,
  onSaveModel,
  isModelSaving,
  modelSaveSuccess,
  onOpenDataLogs,
  onShowExplanations,
  hasExplanations,
  trainedModelId,
}) => {
  const isModelReady = Boolean(trainedModelId);

  const saveModelIcon = isModelSaving
    ? <Loader2 className="h-5 w-5 mb-1 animate-spin" />
    : modelSaveSuccess
    ? <Check className="h-5 w-5 mb-1" />
    : <Save className="h-5 w-5 mb-1 group-hover:scale-110 transition-transform" />;

  const saveModelLabel = isModelSaving ? 'Saving...' : modelSaveSuccess ? 'Saved!' : 'Save Model';

  const saveModelColor = !isModelReady
    ? 'text-gray-600 cursor-not-allowed'
    : isModelSaving
    ? 'text-blue-400 cursor-not-allowed'
    : modelSaveSuccess
    ? 'text-emerald-400'
    : 'text-gray-400 hover:text-gray-100';

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2">
      <div className="bg-gray-900/90 backdrop-blur-sm rounded-xl px-6 py-2 shadow-lg border border-gray-800">
        <div className="flex items-center space-x-8">

          <button
            onClick={onOpenDataLogs}
            className="flex flex-col items-center p-2 text-gray-400 hover:text-gray-100 transition-colors group"
          >
            <Database className="h-5 w-5 mb-1 group-hover:scale-110 transition-transform" />
            <span className="text-xs font-medium">Data</span>
          </button>

          <button
            onClick={onAddNode}
            className="flex flex-col items-center p-2 text-gray-400 hover:text-gray-100 transition-colors group"
          >
            <Plus className="h-5 w-5 mb-1 group-hover:scale-110 transition-transform" />
            <span className="text-xs font-medium">Add Node</span>
          </button>

          <button
            onClick={onRun}
            className="flex flex-col items-center p-2 text-gray-400 hover:text-gray-100 transition-colors group"
          >
            <Play className="h-5 w-5 mb-1 group-hover:scale-110 transition-transform" />
            <span className="text-xs font-medium">Run Pipeline</span>
          </button>

          <button
            onClick={onShowExplanations}
            disabled={!hasExplanations}
            className={`flex flex-col items-center p-2 group transition-colors relative ${
              hasExplanations ? 'text-gray-400 hover:text-indigo-300' : 'text-gray-600 cursor-not-allowed'
            }`}
            title={hasExplanations ? 'View model explanations' : 'Train a model with explanations enabled first'}
          >
            <div className="relative">
              <Eye className="h-5 w-5 mb-1 group-hover:scale-110 transition-transform" />
              {hasExplanations && (
                <div className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              )}
            </div>
            <span className="text-xs font-medium">Explain</span>
          </button>

          <button
            onClick={onSaveModel}
            disabled={!isModelReady || isModelSaving}
            className={`flex flex-col items-center p-2 group transition-colors ${saveModelColor}`}
          >
            {saveModelIcon}
            <span className="text-xs font-medium">{saveModelLabel}</span>
          </button>

        </div>
      </div>
    </div>
  );
};

export default Toolbar;
